import { Activity, BookOpen, Bot, Box, FileText, Gauge, Home, Inbox, MessageSquare, Plug, type LucideIcon } from 'lucide-react'

/* The main panel's pages, in menu order and groups. One list for the Sidebar and the ⌘K palette:
   add a page here and it shows up in both. */

export type MainPage = { id: string; to: string; label: string; title?: string; group: string; icon: LucideIcon; live?: boolean; pendingBadge?: boolean }

export const MAIN_PAGES_NAV: readonly MainPage[] = [
    { id: 'p-home', to: '/', label: 'Início', group: 'Operação', icon: Home },
    { id: 'p-live', to: '/ao-vivo', label: 'Ao Vivo', title: 'Ao Vivo · agentes trabalhando agora', group: 'Operação', icon: Activity, live: true },
    { id: 'p-review', to: '/revisao', label: 'Precisa de você', group: 'Operação', icon: Inbox, pendingBadge: true },
    { id: 'p-forms', to: '/fichas', label: 'Fichas', title: 'Fichas do último Live', group: 'Operação', icon: FileText },
    { id: 'p-agents', to: '/agentes', label: 'Agentes', group: 'Agentes', icon: Bot },
    { id: 'p-ask', to: '/pergunte', label: 'Pergunte', group: 'Agentes', icon: MessageSquare },
    { id: 'p-memory', to: '/memoria', label: 'Memória', group: 'Agentes', icon: BookOpen },
    { id: 'p-connections', to: '/conexoes', label: 'Conexões', group: 'Sistema', icon: Plug },
    { id: 'p-usage', to: '/consumo', label: 'Consumo de IA', group: 'Sistema', icon: Gauge },
    { id: 'p-world', to: '/mundo', label: 'Mundo 3D', title: 'Mundo 3D · a ChildFund por dentro', group: 'Sistema', icon: Box },
]
